import React from 'react'
import Price from 'components/Price'
import { informationTotal} from 'config';
import {useViewportMediaQuery} from 'hooks' 
import style from './style.scss'

const Totals = ({
    discount,
    discountTcenco,
    disabled,
    discountColaborator,
    forceShipping,
    isCatPayment,
    maxAmountPrice,
    selectedSla,
    shipping,
    subTotal,
    subtotalStyle,
    successPage,
    tcenco,
    total,
    customTitle,
    amount,
    isCheckout,
    isSticky,
}) => {
    const isMobile = useViewportMediaQuery(1024)
    const message = <div className='totalizer-information-total'>
        Si hay modificaciones mientras armamos tu pedido, el monto final puede variar. Por el momento, se te cobrarán ${amount}. Al terminar de recolectar tu pedido, se realizará el cobro final de los productos enviados.
    </div>

    return (
        <div className="totalizer-totals">
            <div className={'cart-totalizer-total-wrap' + (subtotalStyle ? ' line' : '')}>
                {!!subTotal && (!successPage || isCatPayment) && (
                    <div className={'cart-totalizer-total-cenco' + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                        <div className="cart-totalizer-total-cenco-cont-title">
                            <span className={'cart-totalizer-total-title' + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                                {customTitle}
                            </span>
                            {!(disabled && disabled.cardType) && <span className={'cart-totalizer-total-cenco-title'}>T. Cencosud Scotiabank</span>}
                        </div>
                        <span className={'cart-totalizer-total-tcenco-price' + (discountColaborator || isCatPayment ? ' colaborador' : '')}>
                            {subTotal ? (
                                <Price price={(tcenco + (shipping >= 0 && (selectedSla || forceShipping) ? shipping : 0)) / 100} />
                            ) : (
                                'Por calcular'
                            )}
                        </span>
                    </div>
                )}

                {(!isCatPayment || !subTotal) && (
                    <div
                        className={
                            'cart-totalizer-total' +
                            (discount !== discountTcenco && discountTcenco && subTotal ? '' : ' regular-price') +
                            (discountColaborator ? ' colaborador' : '')
                        }>
                        <div className="cart-totalizer-total-cont-title">
                            <span
                                className={
                                    'cart-totalizer-total-title' + (discount !== discountTcenco && discountTcenco && subTotal ? '' : ' regular-price')
                                }>
                                {customTitle}
                            </span>
                            {!(disabled && disabled.cardType) && (
                                <span
                                    className={
                                        'cart-totalizer-span-total' +
                                        (discount !== discountTcenco && discountTcenco && subTotal ? '' : ' regular-price')
                                    }>
                                    otro medio de pago
                                </span>
                            )}
                        </div>
                        <span
                            className={
                                'cart-totalizer-total-price' + (discount !== discountTcenco && discountTcenco && subTotal ? '' : ' regular-price')
                            }>
                            {subTotal ? (
                                <Price price={(total + (shipping >= 0 && (selectedSla || forceShipping) ? shipping : 0)) / 100} />
                            ) : (
                                'Por calcular'
                            )}
                        </span>
                    </div>
                )}
                {maxAmountPrice && (
                    <div className="express-alert">
                        Tu pedido excede el <strong>monto máximo diario de {maxAmountPrice}.</strong> <br />
                        Para continuar edita tu pedido o crea una lista para guardar tus productos.
                    </div>
                )}
            </div>
            {informationTotal && isCheckout && !isMobile && message}
            {informationTotal && isCheckout && (isMobile && isSticky) && message} 
        </div>
    )
}

export default Totals